var _filter, _rect, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUiUx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "uiGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#F472B6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#EC4899",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 2,
    stdDeviation: 2,
    floodOpacity: 0.15
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "#F8FAFC",
    rx: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 260,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8F0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 40,
    rx: 12,
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 8,
    r: 6,
    fill: "#F472B6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 8,
    r: 6,
    fill: "#8B5CF6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 8,
    r: 6,
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 4,
    width: 40,
    height: 8,
    rx: 4,
    fill: "#475569"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 60)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 40,
    rx: 8,
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 12,
    width: 80,
    height: 16,
    rx: 4,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 60)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 120,
    rx: 8,
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 70,
    height: 10,
    rx: 2,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 30,
    width: 70,
    height: 80,
    rx: 4,
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    width: 90,
    height: 120,
    rx: 8,
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 10,
    width: 70,
    height: 10,
    rx: 2,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 30,
    width: 70,
    height: 80,
    rx: 4,
    fill: "#E2E8F0"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(280, 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 260,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8F0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 40,
    rx: 12,
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 25,
    fill: "#FFFFFF",
    fontFamily: "sans-serif",
    fontSize: 12
  }, "Components"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 30,
    rx: 6,
    fill: "url(#uiGradient)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 20,
    fill: "#FFFFFF",
    fontFamily: "sans-serif",
    fontSize: 12
  }, "Button"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 40)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 40,
    rx: 6,
    fill: "#F1F5F9",
    stroke: "#E2E8F0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 60,
    height: 8,
    rx: 2,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 22,
    width: 40,
    height: 8,
    rx: 2,
    fill: "#CBD5E1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 90)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 30,
    rx: 6,
    fill: "#F1F5F9",
    stroke: "#E2E8F0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 60,
    height: 10,
    rx: 2,
    fill: "#CBD5E1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 130)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 40,
    rx: 6,
    fill: "#F1F5F9",
    stroke: "#E2E8F0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 10,
    width: 30,
    height: 8,
    rx: 2,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 22,
    width: 20,
    height: 8,
    rx: 2,
    fill: "#CBD5E1"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40, 40)",
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#uiGradient)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,20 L28,20 M20,12 L20,28",
    stroke: "#EC4899",
    strokeWidth: 2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(320, 40)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "none",
    stroke: "#64748B",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 40,
    stroke: "#64748B",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    stroke: "#64748B",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 40,
    stroke: "#64748B",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 10,
    x2: 40,
    y2: 10,
    stroke: "#64748B",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 20,
    x2: 40,
    y2: 20,
    stroke: "#64748B",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 30,
    x2: 40,
    y2: 30,
    stroke: "#64748B",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiUx);
export default __webpack_public_path__ + "static/media/ui_ux.a13242d138c8d1cb1c68e983f1a07fd3.svg";
export { ForwardRef as ReactComponent };